import React from 'react';
import SafeIcon from '../common/SafeIcon';

export default function Sidebar({ activeTab, setActiveTab }) {
  const navItems = [
    { id: 'dashboard', label: 'Overview', icon: 'Grid' },
    { id: 'pipeline', label: 'Client Pipeline', icon: 'Columns' },
    { id: 'projects', label: 'Project Budgets', icon: 'Briefcase' },
    { id: 'invoices', label: 'Invoice Tracker', icon: 'FileText' },
    { id: 'guide', label: 'How It Works', icon: 'HelpCircle' },
  ];

  return (
    <aside className="w-64 bg-charcoal-panel border-r border-[#333] hidden md:flex flex-col h-full z-20 relative">
      <div className="p-6">
        <div className="flex items-center gap-3 text-cream font-semibold text-xl tracking-tight">
          <div className="w-8 h-8 rounded-lg bg-invoice-green flex items-center justify-center flex-shrink-0">
            <SafeIcon name="Hexagon" className="w-5 h-5 text-[#111]" />
          </div>
          StudioLedger
        </div>
      </div>

      <nav className="flex-1 px-4 space-y-1.5 mt-4">
        {navItems.map((item) => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                isActive 
                  ? 'bg-invoice-green/10 text-invoice-green shadow-[inset_2px_0_0_0_#10B981]' 
                  : 'text-cream-muted hover:bg-charcoal-light hover:text-cream'
              }`}
            >
              <SafeIcon name={item.icon} className={`w-4 h-4 ${isActive ? 'text-invoice-green' : 'text-cream-muted opacity-70'}`} />
              {item.label}
            </button>
          );
        })}
      </nav>

      <div className="p-4 border-t border-[#333]">
        <div className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-charcoal-light transition-colors cursor-pointer">
          <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-emerald-400 to-emerald-600 flex items-center justify-center text-[#111] font-bold text-sm">
            AE
          </div>
          <div className="flex-1 overflow-hidden">
            <h4 className="text-sm font-medium text-cream truncate">Agency Admin</h4>
            <p className="text-xs text-cream-muted truncate">admin@studio.io</p>
          </div>
          <SafeIcon name="Settings" className="w-4 h-4 text-cream-muted" />
        </div>
      </div>
    </aside>
  );
}